import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

/**
 * 到達した時点でゲストが触るものが何も無いセクションを、Continue を押させずに完了扱いにする。
 * 該当するのは S2 だけ。有料オプションが 0 件で通訳の選択肢も 1 件しか無いとき、S2 に残るのは日時の確認になる。
 * S1 は常に必須入力があり、S3 は電話・国籍が常に必須、S4 はカードと同意があるため対象にしない。
 * 通訳の選択肢が 2 件以上なら選択欄が残るので自動完了しない（D-038）。
 */
export const canAutoCompleteReservationSection = (sectionId: ReservationSectionId, experienceEvent: WabunkaExperienceEventViewModel): boolean =>
  sectionId === 'additionalOptions' && experienceEvent.experienceEventOptions.length === 0 && experienceEvent.interpreterOptions.length <= 1;
